import { ExtrasInterface } from '@/core/domain/extras/models/extras.model';
import { ExtrasRepository } from '@/core/domain/extras/repositories/extras.repository';
import { selectReservation } from '@/core/reservation/store/reservation.selector';
import { environment } from '@/env/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import _ from 'lodash';
import { first, Observable, of, switchMap } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ExtrasImplRepository extends ExtrasRepository {
    constructor(
        private readonly httpClient: HttpClient,
        private readonly store: Store,
    ) {
        super();
    }

    override getExtras(
        id: number,
        coupon?: string,
        category?: string,
        pickupDate?: string,
        returnDate?: string,
    ): Observable<ExtrasInterface> {
        const url = [
            environment.alamoApi.BASE_HOST,
            environment.alamoApi.ENDPOINTS.extras,
            id,
        ].join('/');

        let params = new HttpParams();

        if (coupon) {
            params = params.set('coupon', coupon);
        }
        if (category) {
            params = params.set('category', category);
        }
        if (pickupDate) {
            params = params.set('pickupDate', pickupDate);
        }
        if (returnDate) {
            params = params.set('returnDate', returnDate);
        }
        return this.store.select(selectReservation).pipe(
            first(),
            switchMap((currentReservation) => {
                if (_.get(currentReservation, 'location.location') === 'INT') {
                    return of(this.buildResponse(currentReservation));
                }
                return this.httpClient
                    .get<ExtrasInterface>(url, { params })
                    .pipe(
                        switchMap((extrasResponse: ExtrasInterface) => {
                            const extras: ExtrasInterface = {
                                type: extrasResponse.type,
                                action: extrasResponse.action,
                                notifications: extrasResponse.notifications,
                                data: extrasResponse.data,
                            };
                            return of(extras);
                        }),
                    );
            }),
        );
    }

    private buildResponse(currentReservation: any): ExtrasInterface {
        const coverages = _.get(currentReservation, 'vehicle.coverages', []);
        const extras: ExtrasInterface = {
            type: 'SUCCESS',
            action: 'CONTINUE',
            notifications: [],
            data: {
                extras: {
                    insurances: [],
                    products: [],
                },
            },
        };
        _.forEach(coverages, (item) => {
            extras.data?.extras.insurances.push({
                description: item.description,
                id: item.code,
                code: item.code,
                title: item.title,
                name: item.title,
                price: item.price,
                required: item.required,
                type: item.type,
                location: 'INT',
            });
        });
        return extras;
    }
}
